import { render, staticRenderFns } from "./activeTickets.vue?vue&type=template&id=7564b6ff&"
import script from "./activeTickets.vue?vue&type=script&lang=js&"
export * from "./activeTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports